module.exports = __webpack_public_path__ + "assets/dateRange.21c0ab78.svg";